import React, {FunctionComponent} from "react";

//@ts-ignore
import classNames from "classnames";

import {Container} from "reactstrap";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse
} from "reactstrap";

import {useUser} from "../../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import TokenBalanceHeader from "../Payment/TokenBalanceHeader";
import {BackgroundColorContext, backgroundColors} from "../../contexts/BackgroundColorContext";
import {ThemeContext, themes} from "../../contexts/ThemeContext";
import {useSettings} from "../../contexts/SettingsContext";

interface AdminNavbarProps {
  brandText: string;
  toggleSidebar: any;
  sidebarOpened: boolean;
}

const AdminNavbar: FunctionComponent<AdminNavbarProps> = (props: AdminNavbarProps) => {
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");
  const navigate = useNavigate();

  const {user, logout} = useUser();
  const {openSettings} = useSettings();

  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };

  // toggle user dropdown
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <BackgroundColorContext.Consumer>
      {(backgroundColorContext) => (
        <ThemeContext.Consumer>
          {(themeContext) => (
            <>
              <Navbar className={classNames("navbar-absolute", color)} expand="lg">
                <Container fluid>
                  <div className="navbar-wrapper">
                    <div
                      className={classNames("navbar-toggle d-inline", {
                        toggled: props.sidebarOpened
                      })}
                    >
                      <NavbarToggler onClick={props.toggleSidebar}>
                        <span className="navbar-toggler-bar bar1" />
                        <span className="navbar-toggler-bar bar2" />
                        <span className="navbar-toggler-bar bar3" />
                      </NavbarToggler>
                    </div>
                  </div>
                  <NavbarToggler onClick={toggleCollapse}>
                    <span className="navbar-toggler-bar navbar-kebab" />
                    <span className="navbar-toggler-bar navbar-kebab" />
                    <span className="navbar-toggler-bar navbar-kebab" />
                  </NavbarToggler>
                  <Collapse navbar isOpen={collapseOpen}>
                    <Nav className="ml-auto" navbar>
                      {user.authenticated && (
                        <>
                          <TokenBalanceHeader className="d-flex align-items-center mr-3" />
                          <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle color="default" nav>
                              <div>
                                {user.email} <i className={`fa fa-caret-${dropdownOpen ? "up" : "down"}`}></i>
                              </div>
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-navbar"
                              right
                              tag="ul"
                              onClick={(e) => e.preventDefault()}
                            >
                              {/* Theme Toggle */}
                              <DropdownItem tag="div" className="nav-item" onClick={(e) => e.preventDefault()}>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={() => {
                                    const newTheme = themeContext.theme === themes.light ? themes.dark : themes.light;
                                    themeContext.changeTheme(newTheme);
                                  }}
                                >
                                  <i
                                    className={`fa ${themeContext.theme === themes.light ? "fa-moon" : "fa-sun"} mr-2`}
                                  />
                                  {themeContext.theme === themes.light ? "Dark mode" : "Light mode"}
                                </div>
                              </DropdownItem>

                              {/* Color Theme */}
                              <DropdownItem tag="div" className="nav-item" onClick={(e) => e.preventDefault()}>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={() => {
                                    const newColor =
                                      backgroundColorContext.color === backgroundColors.primary
                                        ? backgroundColors.blue
                                        : backgroundColors.primary;
                                    backgroundColorContext.changeColor(newColor);
                                  }}
                                >
                                  <div
                                    className="color-swatch mr-2"
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor:
                                        backgroundColorContext.color === backgroundColors.primary
                                          ? "#1d8cf8"
                                          : "#fd5d93",
                                      border: "1px solid rgba(255,255,255,0.3)"
                                    }}
                                  />
                                  {backgroundColorContext.color === backgroundColors.primary
                                    ? "Blue theme"
                                    : "Orange theme"}
                                </div>
                              </DropdownItem>

                              <DropdownItem divider tag="li" />

                              <DropdownItem onClick={openSettings}>Settings</DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem
                                onClick={async (e) => {
                                  e.preventDefault();
                                  await logout();
                                }}
                              >
                                Sign out
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                          <li className="separator d-lg-none" />
                        </>
                      )}
                      {!user.authenticated && (
                        <>
                          <NavItem className="nav-item">
                            <NavLink
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/auth/signin");
                              }}
                            >
                              Sign in
                            </NavLink>
                          </NavItem>
                        </>
                      )}
                    </Nav>
                  </Collapse>
                </Container>
              </Navbar>
            </>
          )}
        </ThemeContext.Consumer>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default AdminNavbar;
